import React, { Fragment } from "react";
import cx from "classnames";
import OptionDropdown from "./Components/OptionDropdown";
import { connect } from "react-redux";
import _ from 'lodash';
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { withRouter } from "react-router-dom";
import HeaderLogo from "../AppLogo";

import { setEnableSearchBarOnHeader } from "../../reducers/ThemeOptions";
import SearchBox from "./Components/SearchBox";
import Support from "./Components/Support";
// import MegaMenu from "./Components/MegaMenu";
import UserBox from "./Components/UserBox/UserBox";
import AppMobileMenu from "../AppMobileMenu";
import detect_mobile from "../../utils/detect_mobile";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullscreen: false, // To track fullscreen state
    };

    // Bind the method to ensure correct `this` context
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  toggleFullscreen() {
    const elem = document.documentElement; // Target the entire page

    if (!this.state.isFullscreen) {
      // Enter fullscreen
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { // For Firefox
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { // For Chrome, Safari, and Opera
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { // For IE/Edge
        elem.msRequestFullscreen();
      }
      this.setState({ isFullscreen: true });
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { // For Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { // For Chrome, Safari, and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { // For IE/Edge
        document.msExitFullscreen();
      }
      this.setState({ isFullscreen: false });
    }
  }

  render() {
    let {
      headerBackgroundColor,
      enableHeaderShadow,
      openInput,
      setEnableSearchBarOnHeader,
      page_config,
      searchBar
    } = this.props;
    const { isFullscreen } = this.state;

    let show_search_bar = _.get(page_config, "header.show_search_bar", false);
    let show_support = _.get(page_config, "header.show_support", false);
    let show_feature_icon = _.get(page_config, "header.show_feature_icon", false);

    let checkPath = () => {
      let location = _.get(this.props, "location.pathname");
      switch (true) {
        case location.includes("alert"):
          return 'Alerts';
        case location.includes("parties"):
          return 'Parties';
        case location.includes("portfolios"):
          return 'Portfolios';
        case location.includes("cases"):
          return 'Cases';
        // case location.includes("forms"):
        //   return 'Forms';
        case location.includes("products"):
          return 'Products';
        default:
          return null;
      }
    };

    return (
      <Fragment>
        <CSSTransitionGroup
          component="div"
          className={cx("app-header", headerBackgroundColor, {
            "header-shadow": enableHeaderShadow,
          }, `${detect_mobile() ? "bg-lightBlue" : ""}`)}
          transitionName="HeaderAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}
        >
          {!openInput && <HeaderLogo />}
          <div className="d-block d-md-none w-100">
            <div className="d-flex justify-content-end ">
              <div className="heading-mobile-header">{checkPath()}</div>
            </div>
          </div>
          <div className="d-flex justify-content-end w-100 align-items-center">
            <div id="cwi_header_bar__search" className="flex-grow-1 mx-3">
              {show_search_bar && <SearchBox openInput={openInput} setEnableSearchBarOnHeader={setEnableSearchBarOnHeader} />}
            </div>
            <div className="d-none d-md-block">
              {show_support && !openInput && <Support />}
            </div>

            {/* Toggle fullscreen icon */}
            <i
              className={`fa-solid ${isFullscreen ? 'fa-compress' : 'fa-expand'} text-primary m-2 fs-24 d-none d-md-block cursor-p`}
              onClick={this.toggleFullscreen}
            ></i>

            <UserBox log_out={this.log_out} />
          </div>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  page_config: _.get(state, "my_profile.page_config", {}),
  searchBar: _.get(state, "globalReducer.searchbar"),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setEnableSearchBarOnHeader: (value) =>
      dispatch(setEnableSearchBarOnHeader(value)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
